module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": _vm.tableId
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(c) {
    return _c('th', [_vm._v(" " + _vm._s(c.label))])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44d83dd5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/DataTables.vue
// module id = 719
// module chunks = 1